import React from 'react';
import PropTypes from 'prop-types';

// Maybe consider instead using the FancyHoverImg component ;)
const LazyLoadedImg = ({ className, src, ...props }) => (
	<img {...props} className={`${className || ''} lazyload`} data-src={src} />);

LazyLoadedImg.propTypes = {
	className: PropTypes.string,
	src: PropTypes.string.isRequired,
};

export default LazyLoadedImg;
